import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

// import { InsuranceBox } from "./insurance";

import features1 from "../../../static/images/carsubs/cardetailcs/advantage1.svg";
import features2 from "../../../static/images/carsubs/cardetailcs/advantage2.svg";
import features3 from "../../../static/images/carsubs/cardetailcs/advantage3.svg";
import features4 from "../../../static/images/carsubs/cardetailcs/advantage4.svg";
import features5 from "../../../static/images/carsubs/cardetailcs/advantage5.svg";
import features6 from "../../../static/images/carsubs/cardetailcs/advantage6.svg";
import features7 from "../../../static/images/carsubs/cardetailcs/advantage7.svg";

const FEATURES = [

	{
		id: 1,
		img: features1,
		title: "Thủ tục đơn giản",
	
	},
	{
		id: 2,
		img: features2,
		title: "Không tốn phí bảo hiểm, phí đường bộ và phí bảo dưỡng xe",
	},
	{
		id: 3,
		img: features3,
		title: "Dịch vụ giao xe và bảo dưỡng tận nhà miễn phí",
	},
	{
		id: 4,
		img: features4,
		title: "Không lo xe bị mất giá hằng năm",
	},
	{
		id: 5,
		img: features5,
		title: "Không cần đi vay, không lo áp lực trả lãi"
	},
    {
		id: 6,
		img: features6,
		title: "Linh động thời gian, sử dụng theo nhu cầu",
	},
    {
		id: 7,
		img: features7,
		title: "Trải nghiệm nhiều dòng xe khác nhau theo ý muốn",
	},
];

const FeatureItem = ({ id, img, alt, title, sub, func }) => {
	return (
        <div className="item item-inner"> 
            <img loading="lazy" src={img} />
             <p>{title}</p>
        </div>
		// <div className={`features-item ${id === 6 ? "pointer" : ""}`} onClick={id === 6 ? func : null}>
		// 	<div className="features-item__img">
		// 		<img loading="lazy" src={img} alt={alt} />
		// 	</div>
		// 	<h5>{title}</h5>
		// 	<p dangerouslySetInnerHTML={{ __html: sub }} />
		// </div>
	);
};

const Advantage = () => {
	const [showInsBox, setShowInsBox] = useState(false);

	const toggleInsBox = () => {
		setShowInsBox(!showInsBox);
	};

	return (
		<div className="features-section advantage-box space sec">
			<div className="m-container">
				<h2>Ưu Điểm Thuê Xe Dài Hạn MiCar</h2>
				{/* <h5 className="title">Những tính năng giúp bạn dễ dàng hơn khi thuê xe trên&nbsp;Mioto.</h5> */}
                <div className="col4-mg15 advantage-inner">
					{FEATURES.map((feature) => (
						<FeatureItem
							key={feature.id}
							img={feature.img}
							alt={feature.alt}
							title={feature.title}
						/>
					))}
				</div>
				<div className="features-swiper-container">
					<Swiper
						className={`swiper-features`}
						spaceBetween={10}
						slidesPerView={1}
						modules={[Pagination]}
						pagination={{
							el: ".pagi-features",
							clickable: true,
							dynamicBullets: true,
						}}>
						{FEATURES.map((feature) => (
							<SwiperSlide key={feature.id}>
								<FeatureItem
									id={feature.id}
									img={feature.img}
									alt={feature.alt}
									title={feature.title}
									sub={feature.sub}
									func={toggleInsBox}
								/>
							</SwiperSlide>
						))}
						<div className="swiper-pagination pagi-features"></div>
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default Advantage;
